import apiSlice from "../../app/api/apiSlice";
import {IProduct} from "../../interfaces";

export type CrossRefProduct = {
    product_id: number;
    brand: string;
    model: string;
    detail_number: string;
    category_name: string;
    slug?: string;
    img: string;
    match_cnt: number;
};

const productsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProduct:builder.query<IProduct, string>({
            query: (param) => `/product/${param}`,
            providesTags: (result) => ['Product'],
        }),
        getProducts:builder.query<IProduct[], void>({
            query: () => "/product",
            providesTags: (result) => ['Product'],
        }),
        getProductsByCategory:builder.query<IProduct[], string>({
            query: (param) => `/product/${param}`,
            providesTags: (result) => ['Product'],
        }),
        getProductsByName: builder.query<IProduct[], string>({
            query: (param) => ({
                url: `/models/${param}`,
            }),
        }),
        getTopSellingProducts: builder.query<IProduct[], void>({
            query: (param) => ({
                url: `/product/top-sellers`,
            }),
        }),
        getModels: builder.query<Array<{img: string, name: string, id: number}>, void>({
            query: () => ({
                url: `/models`,
            }),
            transformErrorResponse: (
                response: { status: string | number; data?: any },
                meta,
                arg
            ) => {
                return response?.data?.error || 'Something went wrong!'
            }
        }),
        searchProduct:builder.query<IProduct[], string>({
            query: (param) => {
                const encodedParam = encodeURIComponent(param);
                return `/product/search?term=${encodedParam}`
            }
        }),
        getCrossReference: builder.query<CrossRefProduct[], number | string>({
            query: (productId) => `/product/cross-reference/${productId}`,
        }),
    })
})

export const {useGetTopSellingProductsQuery, useGetModelsQuery, useGetProductsQuery, useLazySearchProductQuery, useLazyGetProductsQuery, useLazyGetProductsByCategoryQuery, useLazyGetProductQuery, useGetProductsByNameQuery, useGetCrossReferenceQuery} = productsApiSlice

export default productsApiSlice